module.exports = __webpack_public_path__ + "static/img/category_all@3x.94e43e8c.png";